import { Loader } from '@googlemaps/js-api-loader';

export const initMap = (kml: string, data: { zoom: number }) => {
  const loader = new Loader({
    apiKey: 'AIzaSyCwlbkJdDgFRcfRLGZ2vMT0LnJbq32K02k',
    version: 'weekly',
  });

  loader.load().then(async () => {
    const src = kml;

    const { Map } = (await google.maps.importLibrary('maps')) as google.maps.MapsLibrary;
    const map = new Map(document.querySelector('.map_item_wrapper') as HTMLElement, {
      zoom: data.zoom,
    });

    new google.maps.KmlLayer(src, {
      suppressInfoWindows: true,
      preserveViewport: false,
      map: map,
    });
  });
};
